module.exports = __webpack_public_path__ + "img/search-header-nav-below-hyundai.0936430c.png";